export default __webpack_public_path__ + "static/media/FIAT.95eafc7c.png";